function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { post } from './ajax';
import entityActionFactory from './factories/entityActionFactory';
import detailActionFactory from './factories/detailActionFactory';
import changeActionFactory from './factories/changeActionFactory';
import tokenErrorActions from './tokenErrorActionCreators';
const detailActions = detailActionFactory('reportTag', 'reportTags');
const entityActions = entityActionFactory('reportTag', 'reportTags');
const changeActions = changeActionFactory('reportTag', 'reportTags');
const reportTag = _objectSpread(_objectSpread(_objectSpread({}, entityActions), detailActions), changeActions);

/**
 * Saves a collection of reportTags and dispatches a serverIndex
 * event so the user view is updated.
 * @param {Array} objArray - list of reportTags to save
 */
const serverSaveAll = objArray => async (dispatch, getStore) => {
  dispatch(reportTag.saveAll(objArray));
  const url = '/reportTags/saveAll';
  try {
    const response = await post(url, objArray);
    dispatch(reportTag.saveAllSuccess(response.data));
    const {
      indexQuery
    } = getStore().reportTag;
    return dispatch(reportTag.serverIndex(indexQuery));
  } catch (e) {
    return dispatch(tokenErrorActions.handleError(e, 'reportTag', reportTag.saveAllFail.bind(this, e), serverSaveAll.bind(this, objArray)));
  }
};
const serverSave = entityObject => async dispatch => {
  dispatch(reportTag.save(entityObject.id));
  const url = `/reportTags/${entityObject.id}`;
  try {
    await post(url, entityObject);
    dispatch(reportTag.saveSuccess(entityObject.id, entityObject));
  } catch (e) {
    dispatch(tokenErrorActions.handleError(e, 'reportTag', reportTag.saveFail.bind(this, entityObject.id, e), serverSave.bind(this, entityObject)));
  }
};
reportTag.serverSaveAll = serverSaveAll;
reportTag.serverSave = serverSave;
export default reportTag;